import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class EngagementsService {

  headers = new HttpHeaders();

  constructor(private readonly http: HttpClient) { }

  obInfoService() {
    return this.http.get(environment.url + '/MG/Tranck/GetList',
      { headers: this.headers.set('Authorization', sessionStorage.getItem('t_admin')) }).pipe(retry(1), catchError(this.errorHandl));
  }

  updateObService(element) {
    return this.http.put<any>(environment.url + '/MG/Tranck/Update', element, {
      headers: this.headers.set('Authorization',
        sessionStorage.getItem('t_admin'))
    })
      .pipe(retry(1), catchError(this.errorHandl));
  }

  deleteObService(data) {
  
    return this.http.post<any>(`${environment.url}/MG/Tranck/Delete?Id=${data}`, {},
    { headers: this.headers.set('Authorization', sessionStorage.getItem('t_admin')) })
    .pipe(retry(1), catchError(this.errorHandl));
  }

  errorHandl(error) {
    console.log(error)
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    // console.error(errorMessage);
    return throwError(errorMessage);
  }
}
